<template>
  <div>
    <v-text-field
      v-if="conditionType === 'max_ubicaciones_producto' || conditionType === 'level' || conditionType === 'rack'"
      v-model.number="localValue"
      :label="getLabel()"
      type="number"
      min="1"
      :disabled="disabled"
      @input="updateValue"
    ></v-text-field>

    <v-switch
      v-else-if="conditionType === 'temperature'"
      v-model="localValue"
      :label="localValue ? 'Temperatura controlada' : 'Sin control de temperatura'"
      :disabled="disabled"
      @update:model-value="updateValue"
    ></v-switch>

    <v-autocomplete
      v-else-if="conditionType === 'ubicaciones_especificas'"
      v-model="localValue"
      :items="ubicaciones"
      item-title="code"
      item-value="id"
      label="Ubicaciones permitidas"
      multiple
      chips
      clearable
      :rules="arrayRequiredRules"
      required
      :disabled="disabled"
      @update:model-value="updateValue"
    ></v-autocomplete>

    <v-select v-else-if="conditionType === 'zona'" v-model="localValue" :items="zonas" item-title="name" item-value="id" label="Zona" multiple
      chips clearable :rules="arrayRequiredRules" required :disabled="disabled" @update:model-value="updateValue"></v-select>

    <v-select
      v-else-if="conditionType === 'tipo_ubicacion'"
      v-model="localValue"
      :items="tiposUbicacion"
      item-title="name"
      item-value="id"
      label="Tipo de Ubicación"
      multiple
      chips
      clearable
      :rules="arrayRequiredRules"
      required
      :disabled="disabled"
      @update:model-value="updateValue"
    ></v-select>

    <v-text-field v-else v-model="localValue" label="Valor" :disabled="disabled" @input="updateValue"></v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: [String, Array, Number, Boolean],
    conditionType: String,
    zonas: Array,
    tiposUbicacion: Array,
    ubicaciones: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localValue: this.getInitialValue(),
      arrayRequiredRules: [
        v => (v && v.length > 0) || 'Debe seleccionar al menos un valor'
      ],
    };
  },

  watch: {
    modelValue() {
      this.localValue = this.getInitialValue();
    },

    conditionType() {
      this.localValue = this.getInitialValue();
      this.updateValue();
    },
  },

  methods: {
    getInitialValue() {
      if (this.conditionType === "ubicaciones_especificas" || this.conditionType === "zona" || this.conditionType === "tipo_ubicacion") {
        return this.modelValue || [];
      }
      if (this.conditionType === "max_ubicaciones_producto") {
        return this.modelValue || 2;
      }
      if (this.conditionType === "level" || this.conditionType === "rack") {
        return this.modelValue || 1;
      }
      if (this.conditionType === "temperature") {
        return this.modelValue || false;
      }
      return this.modelValue || "";
    },

    updateValue() {
      this.$emit("update:modelValue", this.localValue);
    },

    getLabel() {
      switch (this.conditionType) {
        case "max_ubicaciones_producto":
          return "Máximo de ubicaciones";
        case "level":
          return "Nivel";
        case "rack":
          return "Rack/Pasillo";
        default:
          return "Valor";
      }
    },
  },
};
</script>
